import { render, staticRenderFns } from "./SearchPageTable.vue?vue&type=template&id=3016affc&scoped=true&"
import script from "./SearchPageTable.vue?vue&type=script&lang=js&"
export * from "./SearchPageTable.vue?vue&type=script&lang=js&"
import style0 from "./SearchPageTable.vue?vue&type=style&index=0&id=3016affc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3016affc",
  null
  
)

export default component.exports